/* eslint-disable react/prop-types */
import React from 'react';
import {GridActionsColDef, GridRowParams} from '@mui/x-data-grid-pro';

import { Colors } from '@constants/colors.constants';
import { Checkbox, Stack, styled , Typography} from '@mui/material';
import { Array } from '@utils/extensions/array.extension';
import { ColumnProps } from '@utils/table/columnTypes.table';

const StyledCheckbox = styled(Checkbox)`
  &.Mui-checked {
    background-color: ${Colors.primary};
  }
;
  background-color: #f4f6f8;
  border-radius: 2px;
  width: 30px;
  height: 30px;
`;

interface CheckProps {
  checkedIcon: JSX.Element;
  handleClick?: (row: any, checked: boolean) => void;
  hidden?: (row: any) => boolean;
  isChecked?: (row: any) => boolean;
  uncheckedIcon: JSX.Element;
}

interface ChecksColumnProps extends ColumnProps {
  checkAll?: CheckProps;
  uncheckAll?: CheckProps;
  checks?: CheckProps[];
}

export const COLUMN_TYPE_CHECKS = (props: ChecksColumnProps): GridActionsColDef => ({
  cellClassName: (params) => Array.mapNotNull([props.cellClassName?.(params)])?.join(' ') ?? '',
  field: props.field ?? '',
  headerName: props.label ?? '',
  type: 'actions',
  minWidth: props.minWidth ?? 50,
  width: props.width ?? 150,
  renderHeader: () => {
    return (
      <>
        {props.label &&
            <Typography fontSize="14px" fontWeight="500" color={props.color ? Colors[props.color] : undefined}>
            {props.label}
          </Typography>
        }
        {!!props.checkAll && !props.uncheckAll &&
          <StyledCheckbox
            centerRipple={false}
            onChange={(e, checked) => props.checkAll!.handleClick?.({}, checked)}
            checkedIcon={props.checkAll!.checkedIcon}
            icon={props.checkAll!.uncheckedIcon} />
        }
        {props.checkAll && props.uncheckAll && (
          <Stack direction="row" spacing={1}>
            <StyledCheckbox
              centerRipple={false}
              readOnly={true}
              onClick={() => {
                props.checkAll!.handleClick?.({}, true);
              }}
              checked={true}
              checkedIcon={props.checkAll!.checkedIcon}
              icon={props.checkAll!.checkedIcon} />
            <StyledCheckbox
              checked={false}
              centerRipple={false}
              readOnly={true}
              onClick={() => {
                props.uncheckAll!.handleClick?.({}, false);
              }}
              checkedIcon={props.uncheckAll!.checkedIcon}
              icon={props.uncheckAll!.checkedIcon} />
          </Stack>
        )}
      </>
    );

  },
  valueGetter: props.valueGetter,
  getActions: (params: GridRowParams) => {
    return props?.checks?.map((check) => check.hidden?.(params.row) ? (
      <Stack height="30px" width="30px" alignItems="center" justifyContent="center" color={Colors.text}>
        -
      </Stack>
    ) : (
      <StyledCheckbox
        centerRipple={false}
        onChange={(e, checked) => check.handleClick?.(params.row, checked)}
        checked={check.isChecked?.(params.row)}
        checkedIcon={check.checkedIcon}
        icon={check.uncheckedIcon} />
    )) ?? [];
  },
});
